(ns practitest.frontend.forms3.global-field-form
  (:require [practitest.frontend.common.re-frame :refer [partial-dispatch partial-subscribe partial-dispatch-sync]]
            [practitest.frontend.forms3.entity-form.forms :as forms3]
            [practitest.frontend.forms3.entity-form.fields :as fields3]
            [practitest.frontend.components.forms :as forms-components]
            [practitest.frontend.components.list-builder :as list-builder]
            [practitest.frontend.components2.spinners :refer [mux-spinner]]
            [practitest.frontend.global-fields-settings.events :as global-field-events]
            [goog.object :as gobj]
            [practitest.frontend.global-fields-settings.accordion :refer [accordion-list]]
            [practitest.frontend.global-fields-settings.subs :as global-fields-subs]
            [practitest.frontend.global-fields-settings.common :as global-fields-common]
            [practitest.frontend.global-fields-settings.entity-linker :refer [entity-linker-table]]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [re-frame.core :as re-frame]
            [reagent.core :as re-agent]))

(defn- global-field-fields-props [{:keys [edit? field-format]}]
  (into []
    (concat
      [{:label           (get-translation "global-fields.form-fields.name" "Field Name")
        :field-id        :global-field-name
        :type            :glb-prefixed-text
        :mandatory?      true
        :validators      [::forms-components/string-not-blank]
        :edit-permissions? true
        :max-length      30
        :field-name      :global-field-name}
       {:label           (get-translation "global-fields.form-fields.format" "Field Format")
        :field-id        :global-field-format
        :type            :list
        :mandatory?      (not edit?)
        :validators      [::forms-components/string-not-blank]
        :edit-permissions? (not edit?)
        :label-fn        (fn [item] (global-fields-common/get-field-format-label (:id item)))
        :possible-values ["text" "memo" "number" "list" "date" "datetime" "checkbox" "user" "linkedlist" "multilist" "url"]
        :clear-linked-lists #(re-frame/dispatch [::global-field-events/clear-dependent-fields global-fields-common/global-field-form-id [:global-field-possible-values]])
        :field-name      :global-field-format}]

      (when (= field-format "linkedlist")
        [{:label             "Parent List"
          :field-id          :global-parent-list
          :type              :list
          :mandatory?        true
          :validators        [::forms-components/string-not-blank]
          :edit-permissions? true
          :possible-values  @(re-frame/subscribe [:global-fields-settings/list-field-names])
          :clear-linked-lists #(re-frame/dispatch [::global-field-events/clear-dependent-fields global-fields-common/global-field-form-id [:global-field-possible-values]])
          :field-name        :global-parent-list}]))))

(re-frame/reg-sub
 ::global-fields-props
 (fn [_db [_ edit? field-format field-name]]
   (first (filter #(= (:field-name %) field-name) (global-field-fields-props {:edit? edit? :field-format field-format})))))

(defn- global-fields-form-props [{:keys [edit? field-format]}]
  {:get-field-props (partial-subscribe [::global-fields-props edit? field-format])
   :get-form-state  (partial-subscribe [::forms3/form-state global-fields-common/global-field-form-id])
   :set-form-state  (partial-dispatch [::forms3/set-form-state global-fields-common/global-field-form-id])

   :get-field-state (partial-subscribe [::forms3/field-state global-fields-common/global-field-form-id])
   :set-field-state (partial-dispatch-sync [::forms3/set-field-state global-fields-common/global-field-form-id])})

(defn force-form-validation! [{:keys [edit? field-format]}]
   (let [{:keys [set-form-state
                 get-form-state
                 get-field-props]} (global-fields-form-props {:keys [edit? field-format]})
         new-form-state (let [form-state @(get-form-state)]
                          (reduce
                           (fn [form-state field]
                             (update-in form-state [:fields field]
                                        (fn [field-state]
                                          (let [props @(get-field-props field)]
                                            (assoc field-state :errors (forms-components/validate-all (:validators props) (:value field-state)))))))
                           form-state
                           (map :field-name (global-field-fields-props {:edit? edit? :field-format field-format}))))]
     (set-form-state new-form-state)
     (into {}
           (comp
            (map (fn [[field field-state]]
                   (if (seq (:errors field-state))
                     [field (:errors field-state)]
                     nil)))
            (remove nil?))
           (:fields new-form-state))))

(defn- possible-values-list [edit?]
  (let [field-id :global-field-possible-values
        form-data  @(re-frame/subscribe [::global-fields-subs/global-fields-form-data])
        on-delete-item (fn [item]
                         (mixpanel/track
                          "Delete_Global_Field_Value"
                          {"Type" (get-in form-data [:global-field-format :value])})
                         
                         (if edit?
                           (re-frame/dispatch [::global-field-events/check-item-value-usage item])
                           (re-frame/dispatch [::global-field-events/delete-item-from-create-form item])))
        on-add-item (fn []
                      (mixpanel/track
                       "Adding_Global_Field_Value"
                       {"Type" (get-in form-data [:global-field-format :value])}))
        rename-supported? @(re-frame/subscribe [::global-fields-subs/values-rename-supported?])
        on-edit-item (when (and edit? rename-supported?)
                       (fn [item]
                         (mixpanel/track
                          "Rename_Global_Field_Value"
                          {"Type" (get-in form-data [:global-field-format :value])})
                         (re-frame/dispatch [::global-field-events/open-rename-value-modal item nil])))]
    [:div.g2-field-container
     [:label.m-label.top (get-translation "global-fields.form-fields.values" "Values customization")]
     [list-builder/view-panel field-id (global-fields-form-props {:edit? edit?}) on-delete-item on-add-item
      nil on-edit-item]]))

(defn- linked-values-list [edit? form-data]
  (let [field-id :global-field-possible-values
        parent-list (get-in form-data [:global-parent-list :value])
        parent-list-items @(re-frame/subscribe [:global-fields-settings/list-items parent-list])
        on-delete-item (fn [parent-item]
                         (fn [item]
                           (mixpanel/track
                             "Delete_Global_Field_Value"
                             {"Type" (get-in form-data [:global-field-format :value])})
                           (if edit?
                             (re-frame/dispatch [::global-field-events/check-item-value-usage item (keyword parent-item)])
                             (re-frame/dispatch [::global-field-events/delete-item-from-create-form item (keyword parent-item)]))))
        on-add-item (fn []
                      (mixpanel/track
                        "Adding_Global_Field_Value"
                        {"Type" (get-in form-data [:global-field-format :value])}))
        rename-supported? @(re-frame/subscribe [::global-fields-subs/values-rename-supported?])
        on-edit-item (fn [parent-item]
                       (when (and edit? rename-supported?)
                         (fn [item]
                           (mixpanel/track
                            "Rename_Global_Field_Value"
                            {"Type" (get-in form-data [:global-field-format :value])})
                           (re-frame/dispatch [::global-field-events/open-rename-value-modal item (keyword parent-item)]))))
        view-map (mapv (fn [parent-item]
                         {:id parent-item
                          :title parent-item
                          :body [list-builder/view-panel field-id (global-fields-form-props {:edit? edit?})
                                 (on-delete-item parent-item) on-add-item (keyword parent-item)
                                 (on-edit-item parent-item)]})
                       parent-list-items)]

    (when parent-list
      [:div.g2-field-container
       [:label.m-label.top (get-translation "global-fields.form-fields.values" "Values customization")]
       [accordion-list view-map]])))

(defn- entity-linker [edit?]
   (let [table-id :global-field-entity
         checkbox-id :global-field-select-projects
         form-props (global-fields-form-props {:edit? edit?})
         set-value (:set-field-state form-props)
         get-value (:get-field-state form-props)]
     [:<>
      [:div.g2-field-container
       [:label.m-label (get-translation "global-fields.form-fields.select-projects" "Select Projects")]
       [:div.projects-check
        [:input.m-checkbox {:type :checkbox
                            :checked (:value @(get-value checkbox-id))
                            :on-change (fn [e] (set-value checkbox-id {:value (.. e -target -checked)
                                                                       :dirty? true}))}]
        [:span (get-translation "global-fields.select-projects-info" "Enforce the Global Field to all projects")]]]
      [:div.g2-field-container
       [:label.m-label.top (get-translation "global-fields.form-fields.select-linkage" "Select linkage to Entities")]
       [entity-linker-table table-id form-props]]]))

(defn- render-global-field-form [{:keys [edit?]}]
  (let [form-data @(re-frame/subscribe [::global-fields-subs/global-fields-form-data])
        field-format (get-in form-data [:global-field-format :value])
        loading? @(re-frame/subscribe [:global-fields-settings/form-loading?])]
    (if loading?
      [:div.spinner-container [mux-spinner]]
      [:div.global-field-form
       (doall (map (fn [props]
                     (with-meta [fields3/build-field props (global-fields-form-props {:edit? edit? :field-format field-format})]
                                {:key (:field-id props)}))
                   (global-field-fields-props {:edit? edit? :field-format field-format})))
       (cond
         (#{"list" "multilist"} field-format) [possible-values-list edit?]
         (= field-format "linkedlist") [linked-values-list edit? form-data])
       [entity-linker edit?]])))

(defn- global-field-form-edit []
  (let [global-field-id @(re-frame/subscribe [::global-fields-subs/global-field-id])
        global-fields @(re-frame/subscribe [:global-fields-settings/get-all-fields])
        edit-global-field (first (filter (fn [field] (= (str (:id field)) (str global-field-id))) global-fields))]
    (if edit-global-field
      (re-frame/dispatch [::global-field-events/init-form-values edit-global-field])
      ;; redirect to permission error page when account does not have such global field
      (.replace (gobj/get js/document "location") "/permission_error"))
    (fn []
      [render-global-field-form {:edit? true}])))

(defn global-field-form [{:keys [edit?]}]
  (let [init-done? @(re-frame/subscribe [:global-fields-settings/init-complete?])]
    (when init-done?
      (if edit?
        [global-field-form-edit]
        [render-global-field-form {:edit? edit?}]))))